import { render, staticRenderFns } from "./AccessDeniedComponent.vue?vue&type=template&id=59a90ea9&scoped=true"
import script from "./AccessDeniedComponent.vue?vue&type=script&lang=ts"
export * from "./AccessDeniedComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a90ea9",
  null
  
)

export default component.exports